import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "m14 7-5 5 5 5V7z",
  fill: "currentColor"
}));
export default SvgArrowLeft;